import React from 'react';
import { Link } from 'react-router-dom';
import { Map, Shield, Users, Zap, Coins, Brain, Bell, TrendingUp, Wallet, LogOut } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useWeb3 } from '../context/Web3Context'; 
import '../styles/global.css';

const Landing = () => {
  const { theme } = useTheme();
  const { account, disconnectWallet, formatAddress, nativeBalance } = useWeb3();
  
  const newsItems = [
    { source: "Times of India", title: "StakeStreet launches first prediction market for urban infrastructure.", time: "2h ago" },
    { source: "Hindustan Times", title: "Monad Blockchain Foundation grants $5M to StakeStreet.", time: "3h ago" },
    { source: "TechCrunch", title: "Jaipur becomes the first city to adopt decentralized road monitoring.", time: "5m ago" },
    { source: "CoinDesk", title: "User 'Rahul_S' earns 500 MON for verifying 50 potholes.", time: "10m ago" },
  ];

  return (
    <div style={{ paddingBottom: '0px', overflowX: 'hidden' }}>
      
      {/* --- IMPORT COOL FONT --- */}
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@900&display=swap');`}
      </style>

      {/* 1. HERO SECTION */}
      <div className="container" style={{ 
        minHeight: '85vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        textAlign: 'center', 
        paddingTop: '130px', // <--- FIXED: Clears the Navbar so badge is visible
        position: 'relative' 
      }}>
        
        {/* Background Blob */}
        <div style={{ 
          position:'absolute', top:'30%', left:'50%', transform:'translate(-50%, -50%)', 
          width:'600px', height:'600px', 
          background: 'var(--blob-color)',
          zIndex:-1,
          opacity: 0.6
        }}></div>

        <div style={{ maxWidth: '900px' }}>
          
          {/* BADGE */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', borderRadius: '50px', background: 'rgba(139, 92, 246, 0.1)', border: '1px solid #8b5cf6', color: '#8b5cf6', fontWeight: '600', marginBottom: '30px', fontSize: '0.9rem' }}>
            <Zap size={16} fill="#8b5cf6" color="#8b5cf6" /> Live on Monad Testnet
          </div>
          
          {/* HEADLINE */}
          <h1 className="text-gradient" style={{ 
            fontFamily: "'Orbitron', sans-serif", 
            fontSize: '4.2rem', 
            fontWeight: '900', 
            lineHeight: '1.1', 
            marginBottom: '30px',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          }}>
            TURN POTHOLES <br/> INTO PAYDAYS
          </h1>
          
          <p style={{ fontSize: '1.3rem', color: 'var(--text-muted)', marginBottom: '50px', lineHeight: '1.6', maxWidth: '700px', margin: '0 auto 50px auto' }}>
            Don't just dodge hazards—<strong>profit from them.</strong> <br/>
            The first <strong>Social-Fi Prediction Market</strong> for real-world infrastructure. 
            Stake MON. Verify Reality. <strong>Get Paid.</strong>
          </p>

          {/* WALLET CARD */}
          {account && (
            <div className="glass-panel" style={{ 
              display: 'inline-flex', alignItems: 'center', gap: '25px', padding: '15px 30px', 
              marginBottom: '40px', background: 'rgba(16, 185, 129, 0.05)', border: '1px solid rgba(16, 185, 129, 0.3)' 
            }}>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Wallet size={14} /> Connected Wallet
                </div>
                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#10b981', fontFamily: 'monospace' }}>
                  {formatAddress(account)}
                </div>
              </div>

              <div style={{ height: '35px', width: '1px', background: 'var(--glass-border)' }}></div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Your Balance</div>
                <div style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'var(--text-main)' }}>
                   {nativeBalance} MON
                </div>
              </div>

              <div style={{ marginLeft: '10px' }}>
                <button 
                  onClick={disconnectWallet}
                  className="glass-btn" 
                  style={{ 
                    padding: '10px 16px', fontSize: '0.85rem', color: '#ef4444', borderColor: 'rgba(239, 68, 68, 0.3)',
                    display: 'flex', alignItems: 'center', gap: '6px' 
                  }}
                  title="Disconnect Wallet"
                >
                  <LogOut size={14} /> Exit
                </button>
              </div>
            </div>
          )}
          
          {/* ACTION BUTTONS */}
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginBottom: '60px' }}>
            <Link to="/map" className="btn-primary" style={{ padding: '18px 40px', fontSize: '1.2rem', display:'flex', alignItems:'center', gap:'10px', textDecoration:'none' }}>
              <Map size={24} /> Launch Live Map
            </Link>
            <Link to="/community" className="glass-btn" style={{ padding: '18px 40px', fontSize: '1.2rem', textDecoration:'none', color: 'var(--text-main)', borderColor: 'var(--glass-border)' }}>
              Join Community
            </Link>
          </div>
        </div>
      </div>

      {/* 2. LIVE NEWS FEED */}
      <div style={{ 
        width: '100%',
        background: 'rgba(0, 0, 0, 0.3)', 
        borderTop: '1px solid var(--glass-border)', 
        borderBottom: '1px solid var(--glass-border)', 
        padding: '15px 0',
        marginTop: '20px'
      }}>
        <div className="container" style={{ 
          margin: '0 auto', 
          padding: '0 20px', 
          display: 'flex', 
          alignItems: 'center', 
          maxWidth: '1200px', 
          gap: '30px'
        }}>
          
          {/* Label */}
          <div style={{ display:'flex', alignItems:'center', gap:'10px', color:'#f59e0b', fontWeight:'bold', fontSize:'1.1rem', whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '1px' }}>
            <TrendingUp size={24} /> LIVE INTEL:
          </div>

          {/* Ticker Window */}
          <div className="news-ticker-viewport" style={{ height: '50px', overflow: 'hidden', position: 'relative', flex: 1 }}>
            <div className="news-ticker-track">
              {newsItems.map((item, index) => (
                <div key={index} style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                  <div style={{ fontSize: '1.1rem', color: 'var(--text-main)', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <span style={{ color: 'var(--primary)', fontWeight: '700', marginRight: '10px' }}>[{item.source}]</span> 
                    {item.title} 
                    <span style={{ fontSize: '0.85rem', color: '#94a3b8', marginLeft: '15px' }}>({item.time})</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* 3. FEATURES GRID */}
      {/* FIXED: Reduced top padding from 100px to 50px to close the gap */}
      <div className="container" style={{ padding: '50px 20px 100px' }}>
        <h2 style={{ fontSize: '3rem', marginBottom: '20px', textAlign: 'center', color: 'var(--text-main)', fontFamily: "'Orbitron', sans-serif" }}>Built for Impact</h2>
        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '1.1rem', marginBottom: '60px' }}>Everything you need to improve your city and earn rewards.</p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          <FeatureCard icon={Map} title="Real-time Mapping" desc="Interactive maps with live hazard updates." theme={theme} />
          <FeatureCard icon={Zap} title="Safe Route Planning" desc="AI-optimized routes prioritizing safety." theme={theme} />
          <FeatureCard icon={Users} title="Community Validation" desc="Crowdsourced verification ensures accuracy." theme={theme} />
          <FeatureCard icon={Brain} title="AI Intelligence" desc="Smart analysis of patterns and predictions." theme={theme} />
          <FeatureCard icon={Coins} title="Native MON Staking" desc="No extra tokens needed. Stake MON directly to report and earn." theme={theme} />
          <FeatureCard icon={Bell} title="Smart Alerts" desc="Get notified about hazards on your route." theme={theme} />
        </div>
      </div>

      <style>{`
        @keyframes scrollUp { 
          0% { transform: translateY(0); } 
          100% { transform: translateY(-200px); } 
        }
        .news-ticker-track { animation: scrollUp 10s linear infinite; } 
        
        .text-gradient {
          background: linear-gradient(to right, #ffffff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>
    </div>
  );
};

// --- HELPER COMPONENTS ---
const FeatureCard = ({ icon: Icon, title, desc, theme }) => (
  <div className="glass-panel" style={{ 
    padding: '30px', transition: 'transform 0.2s', cursor:'default',
    background: 'var(--glass-bg)', border: '1px solid var(--glass-border)', boxShadow: 'var(--card-shadow)'
  }}>
    <div style={{ width:'50px', height:'50px', background: theme === 'light' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(255,255,255,0.05)', borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'20px' }}>
      <Icon size={24} color="#10b981" />
    </div>
    <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: 'var(--text-main)', fontFamily: "'Orbitron', sans-serif" }}>{title}</h3>
    <p style={{ fontSize: '1rem', color: 'var(--text-muted)', lineHeight: '1.6' }}>{desc}</p>
  </div>
);

export default Landing;